import MapBaseLayer from '@alltrails/amplitude/enums/MapBaseLayer';
import MapDrawerLocation from '@alltrails/amplitude/enums/MapDrawerLocation';
import MapLocation from '@alltrails/amplitude/enums/MapLocation';
import MapOverlay from '@alltrails/amplitude/enums/MapOverlay';
import { baseMapStyles, conditionsStyles, extraStyles } from '../components/LayerMenu/LayerMenu';
import { BaseStyleId, DynamicStyleId, StaticStyleId } from '../types/Styles';

export const getMapBaseLayer = (styleId: BaseStyleId): MapBaseLayer | undefined => {
  switch (styleId) {
    case 'adminBasemap':
      return 'custom';
    case 'alltrailsOutdoorsV2':
      return 'alltrailsv2';
    case 'alltrailsSatellite':
    case 'alltrailsSatelliteMinimal':
    case 'googleSatellite':
      return 'satellite';
    case 'opencycle':
      return 'ocm';
    case 'openstreet':
      return 'osm';
    case 'roadmap':
      return 'road';
    case 'topo':
      return 'topo';
    case 'worldparks':
      return 'worldparks';
    case 'worldtopo':
      return 'worldtopo';
    default:
      return undefined;
  }
};

export const getMapOverlay = (styleId: StaticStyleId | DynamicStyleId): MapOverlay | undefined => {
  switch (styleId) {
    case 'adminOverlay':
      return 'custom overlay';
    case 'after':
      return 'recordings last 60 days';
    case 'communityActivity':
      return 'community activity';
    case 'groundConditions':
      return 'ground conditions';
    case 'heatmap':
      return 'heatmap';
    case 'nearbyTrails':
      return 'nearby_trails';
    case 'newHeatmap':
      return 'heatmap';
    case 'photos':
      return 'photos';
    case 'precipitation':
      return 'precipitation';
    case 'recordingsAll':
      return 'recordings all';
    case 'snowDepth':
      return 'snow-depth';
    case 'surfaceType':
      return 'surface';
    case 'temperature':
      return 'temperature';
    case 'waypoints':
      return 'waypoints';
    case 'publicLands':
      return 'public lands';
    default:
      return undefined;
  }
};

export const getPage = (pathname: string): MapLocation => {
  if (pathname.includes('/custom-routes')) {
    return 'custom route';
  }
  if (pathname.includes('/explore')) {
    return 'explore';
  }
  if (pathname.includes('/trail')) {
    return 'trail';
  }

  return '' as MapLocation;
};

export const getMapDrawerLocation = (styleId: StaticStyleId | DynamicStyleId): MapDrawerLocation => {
  if (baseMapStyles.includes(styleId as BaseStyleId)) {
    return 'base map';
  }
  if (conditionsStyles.includes(styleId as StaticStyleId) || styleId === 'heatmap') {
    return 'conditions';
  }
  if (extraStyles.includes(styleId as StaticStyleId)) {
    return 'extras';
  }

  return '' as MapDrawerLocation;
};
